import { CustomerInteractionType } from "../bonusRule/CustomerInteractionType";

export enum InteractionType {
  PAYMENT_INTERACTION = "PAYMENT_INTERACTION",
  CUSTOMER_INTERACTION = "CUSTOMER_INTERACTION",
  COUPON_INTERACTION = "COUPON_INTERACTION",
  BONUS_XPRESS_INTERACTION = "BONUS_XPRESS_INTERACTION",
  REVERSAL_INTERACTION = "REVERSAL_INTERACTION",
  BONUS_XPRESS_REVERSAL_INTERACTION = "BONUS_XPRESS_REVERSAL_INTERACTION",
  ADJUSTMENT_EARN_INTERACTION = "ADJUSTMENT_EARN_INTERACTION",
  ADJUSTMENT_BURN_INTERACTION = "ADJUSTMENT_BURN_INTERACTION",
  EXPIRED_REWARD_INTERACTION = "EXPIRED_REWARD_INTERACTION",
  CLEAR_BONUS_POINTS_INTERACTION = "CLEAR_BONUS_POINTS_INTERACTION",
  CASHBACK_BURN_INTERACTION = "CASHBACK_BURN_INTERACTION",
}

export interface CustomerInteractionDto {
  customerNumber: string;
  interactionNumber: string;
  interactionTimestamp: string;
  interactionType: InteractionType;
  customerInteractionType?: CustomerInteractionType;
  externalUnitNumber?: string;
  rewardedInteractions?: RewardedInteractionDto[];
  paymentAmount?: string;
  reversalAmount?: string;
  reversalCashValue?: string;
  cashValue?: string;
  bonusPoints?: string;
  stampCard?: string;
  totalBonusPoints: string;
  externalReceiptId?: string;
  externalReferenceReceiptId?: string;
  externalIdentificationNumber?: string;
  note?: string;
  username?: string;
}

export interface RewardedInteractionDto {
  bonusPoints: string;
  stampCard?: string;
  bonusReason: string;
  validFrom: string;
  validTill: string;
  rewardType?: "BONUS_POINT" | "STAMP_CARD";
}
